export default function changeLang(){
    $("#changeLang").on('change', function () {
        let lang = $("#changeLang").val();
        let urlCurrent = $("#routeCurrent").val();
        let url = $("#langFunction").val();
        var dataString = 'lang=' + lang;
        $.ajax({
            type: "POST",
            url: url,
            headers: {
              'X-CSRF-Token': $('input[name="_token"]').val()
              },
            data: dataString,
            dataType: 'json',
            success: function (json) {
                window.location.replace(urlCurrent);
            }
        });
    });
}
